import basePropertyOf from './_basePropertyOf.js';

/** Used to map HTML entities to characters. */
var htmlUnescapes = {
  '&amp;': '&',
  '&lt;': '<',
  '&gt;': '>',
  '&quot;': '"',
  '&#39;': "'"
};

/**
 * Used by `_.unescape` to convert HTML entities to characters.
 *
 * @private
 * @param {string} chr The matched character to unescape.
 * @returns {string} Returns the unescaped character.
 */
var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

export default unescapeHtmlChar;



//////////////////
// WEBPACK FOOTER
// ./~/lodash-es/_unescapeHtmlChar.js
// module id = 2304
// module chunks = 67